let _ = (t)=>t, t;
import { jsx as _jsx } from "react/jsx-runtime";
import { css } from '@emotion/react';
import { tokens } from '@klarna/ui';
import RichTextMarkdown from 'features/richText/components/richTextMarkdown/RichTextMarkdown';
const backgroundTextColorTokenMap = {
    primary: 'text/subtle',
    secondary: 'text/body',
    inverse: 'text/inverse'
};
const TextBlock = ({ component })=>{
    var _ref;
    var _component_blockOptions;
    const background = (_component_blockOptions = component.blockOptions) === null || _component_blockOptions === void 0 ? void 0 : _component_blockOptions.backgroundColor;
    const textColorToken = (_ref = background && backgroundTextColorTokenMap[background]) !== null && _ref !== void 0 ? _ref : 'text/body';
    return /*#__PURE__*/ _jsx(RichTextMarkdown, {
        sx: css(t || (t = _`
        max-width: 100%;

        p,
        p > * {
          color: ${0};
          font-size: ${0}px;
          line-height: ${0}px;
        }
      `), tokens.colors.light[textColorToken], tokens.textSizes['text/desktop/s'], tokens.lineHeights['body/desktop/s']),
        children: component.content
    });
};
export default TextBlock;
